import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_u89gdyfh23: FaireBrandEntity = {
  token: "b_u89gdyfh23",
  type: "brand",
  name: "Roomytown Inc",
  avatarUrl:
    "https://cdn.faire.com/fastly/72d48ea74303a6f29934c4e25291df7a1733493816ff272d1ee1642451a5c6a8.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/7ec14f04e96b5568d285bbf694fb53e19bb3d3501fd8603bb7c468fe25c5908d.png",
  logoUrl:
    "https://cdn.faire.com/fastly/72d48ea74303a6f29934c4e25291df7a1733493816ff272d1ee1642451a5c6a8.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/7ec14f04e96b5568d285bbf694fb53e19bb3d3501fd8603bb7c468fe25c5908d.png",
  location: "Newark, DE, USA",
  minimumOrderDollars: 250,
  rating: 4.9,
  reviewCount: 41,
  isTopShop: true,
  isInsider: true,
  description:
    "We bring new life to forgotten treasures — uncovering untold stories in archival designs and reimagining them as meaningful homeware, stationery and games that enrich our homes.\n\nOur process begins with discovery. We source centuries-old illustrations from antique books, museum archives and flea markets, drawn to pieces with character, detail, and a sense of intrigue. Back in our Bath studio in the UK, each design is carefully restored and reinterpreted — preserving its essence while giving it a fresh, contemporary perspective.\nThe result is a collection that feels layered and distinctive. From art prints and enamel trays to playing cards and tea towels, every piece carries a quiet sense of provenance — designed to bring depth, personality, and warmth into everyday spaces.\nWe don’t design for trends, but for longevity. Our collections are thoughtfully developed to sit comfortably in both classic and contemporary settings, offering customers something that feels both familiar and unexpected.\n\nToday, Roomytown is stocked by leading museums and independent retailers worldwide, valued for its strong visual identity, cohesive ranges, and story-led appeal.\nAt its heart, Roomytown is about living with objects that have a past — and creating homes that feel collected, considered, and full of character.",
  meta: {
    source: "api",
    importedAt: "2026-06-24T21:39:59.984Z",
    importedBy: "entity-db-cli",
  },
};
